import { HttpBase } from '@library/Security';
import type { IServiceInterval, IServiceSchedule, IVehicleConditionDto, IVehicleEditableProperties } from '@domain/Vehicle';
import type { IMyGarageViewModelDto } from '@app/MyGarage';
import { useUser } from '@domain/Security/User';

export class MyGarageApi extends HttpBase
{

    private getPayload = ( otherParams: object ) =>
    {
        const user = useUser();
        return {
            vehicleId: user?.activeVehicle.vehicleId,
            ...otherParams
        };
    };

    /**
     * Gets the MyGarage view model
     * @param appConsumerId
     * @param appVehicleId
     * @returns
     */
    async getViewModelAsync( appConsumerId: string, vehicleId: string ): Promise<IMyGarageViewModelDto|null>
    {
        const result = await this.get( `api/consumer/${ appConsumerId }/vehicles/${ vehicleId }` );
        if( !result.success ) return null;
        return result.data;
    }

    /**
     * Updates the vehicle properties
     * @param properties
     */
    async updateVehicleProperties( properties: IVehicleEditableProperties ) : Promise<IVehicleConditionDto|null>
    {
        const payload = this.getPayload( properties );
        const result = await this.put( 'api/vehicle', payload );
        if( result.success ) return result.data as IVehicleConditionDto;
        return null;
    }

    /**
     * Updates the service schedule state
     * @param interval
     */
    async updateServiceSchedule( schedule: IServiceSchedule ): Promise<boolean>
    {
        const payload = this.getPayload( { serviceScheduleId: schedule.serviceScheduleId, nextInterval: schedule.nextInterval } );
        const result = await this.put( 'api/vehicle/update-service-schedule', payload );
        return result.success;
    }

    /**
     * Updates the service interval state
     * @param interval
     */
    async updateServiceInterval( interval: IServiceInterval ): Promise<boolean>
    {
        const payload = this.getPayload( { interval } );
        const result = await this.put( 'api/vehicle/update-service-interval', payload );
        return result.success;
    }

}

export const useMyGarageApi = () => new MyGarageApi();
